import React from "react";
import { categoryLabel } from "../services/matchService.js";

/** "✓ RCPT-12 • Ravi Stores" / "🔗 …" for a matched bank line, "✓ Bank charges" for a category match. */
export function matchLabel(t) {
  if (t.paymentNo) return `${t.matchType === "linked" ? "🔗" : "✓"} ${t.paymentNo} • ${t.partyName || ""}`;
  return `✓ ${categoryLabel(t.matchType)}`;
}

/** Desktop table for a bank account's transactions (read-only; matching happens on "To match"). */
export function bankTxnColumns({ fmt, rupees }) {
  return [
    {
      key: "date",
      label: "Date",
      width: 120,
      sortValue: (t) => `${t.date || ""} ${t.time || ""}`,
      render: (t) => fmt(t.date)
    },
    { key: "description", label: "Description", render: (t) => t.description || <span className="text-dim">—</span> },
    { key: "ref", label: "Ref / UTR", width: 170, optional: true, render: (t) => t.ref || <span className="text-dim">—</span> },
    {
      key: "creditPaise",
      label: "Money in",
      width: 130,
      align: "right",
      className: "amount",
      sortValue: (t) => Number(t.creditPaise || 0),
      render: (t) => (t.creditPaise ? <span className="text-success">+{rupees(t.creditPaise)}</span> : "")
    },
    {
      key: "debitPaise",
      label: "Money out",
      width: 130,
      align: "right",
      className: "amount",
      sortValue: (t) => Number(t.debitPaise || 0),
      render: (t) => (t.debitPaise ? <span className="text-danger">−{rupees(t.debitPaise)}</span> : "")
    },
    {
      key: "balancePaise",
      label: "Balance",
      width: 130,
      align: "right",
      optional: true,
      className: "amount",
      sortValue: (t) => (t.balancePaise ?? null),
      render: (t) => (t.balancePaise !== null && t.balancePaise !== undefined ? rupees(t.balancePaise) : "")
    },
    {
      key: "matchStatus",
      label: "Matched to",
      width: 220,
      sortValue: (t) => (t.matchStatus === "matched" ? matchLabel(t) : ""),
      render: (t) => (t.matchStatus === "matched" ? <span className="text-success">{matchLabel(t)}</span> : <span className="text-dim">Not matched</span>)
    }
  ];
}
